<template>
  <div class="py-0 container-fluid">
    <div class="row">
      <div class="col-md-12 bg-white border-radius-xl p-3 mb-3">
        <div class="row">
          <div class="col-md-1"></div>
          <div class="col-md-10">
            <div class="row">
              <div class="col-md-3">
                <label class="form-control-label">Documento de Identidad <span class="text-danger">*</span></label>
                <input
                  type="text"
                  class="form-control"
                  v-model="documentoIdentidad"
                  @update:modelValue="validarFiltros"
                >
              </div>
              <div class="col-md-3">
                <label for="example-text-input" class="form-control-label">Desde</label>
                <datepicker
                  v-model="fechaInicio"
                  v-bind="basicConfigDatePicker"
                  :max-date="fechaFin || null"
                  @update:modelValue="validarFiltros"
                />
                  <!-- :name="String(n)" -->
              </div>
              <div class="col-md-3">
                <label class="form-control-label">Hasta</label>
                <datepicker
                  v-model="fechaFin"
                  v-bind="basicConfigDatePicker"
                  :min-date="fechaInicio || null"
                  @update:modelValue="validarFiltros"
                />
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-addiuva-dark w-100"
                  style="margin-top: 32px;"
                  title="Generar"
                  v-if="!error"
                  :disabled="!documentoIdentidad"
                  @click="getData"
                >
                  <i class="fas fa-search pr-1"></i> Generar
                </button>
                <div v-if="error" class="error-message">
                  {{ error }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-1"></div>
        </div>
      </div>
      <div class="col-lg-12">
        <div class="row mb-0">
          <div class="col-lg-4 col-md-6 col-12">
            <card
              :title="stats.ventas.title"
              :titleColor="'text-addiuva-dark'"
              :value="stats.ventas.value"
              :percentage="stats.ventas.percentage"
              :iconClass="stats.ventas.iconClass"
              :iconBackground="stats.ventas.iconBackground"
              :detail="stats.ventas.detail"
              directionReverse
            ></card>
          </div>
          <div class="col-lg-4 col-md-6 col-12">
            <card
              :title="stats.cantidadProductos.title"
              :value="stats.cantidadProductos.value"
              :percentage="stats.cantidadProductos.percentage"
              :percentageColor="stats.cantidadProductos.percentageColor"
              :iconClass="stats.cantidadProductos.iconClass"
              :iconBackground="stats.cantidadProductos.iconBackground"
              :detail="stats.cantidadProductos.detail"
              directionReverse
            ></card>
          </div>
          <!-- <div class="col-lg-4 col-md-6 col-12">
            <card
              :title="stats.clients.title"
              :value="stats.clients.value"
              :percentage="stats.clients.percentage"
              :iconClass="stats.clients.iconClass"
              :iconBackground="stats.clients.iconBackground"
              :percentageColor="stats.clients.percentageColor"
              :detail="stats.clients.detail"
              directionReverse
            ></card>
          </div> -->
          <div class="col-lg-4 col-md-6 col-12">
            <card
              :title="stats.sales.title"
              :value="stats.sales.value"
              :valueColor="stats.sales.valueColor"
              :percentage="stats.sales.percentage"
              :percentageColor="stats.sales.percentageColor"
              :iconClass="stats.sales.iconClass"
              :iconBackground="stats.sales.iconBackground"
              :detail="stats.sales.detail"
              directionReverse
            ></card>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 px-3 px-1">
            <div class="bg-white border-radius-lg">
              <ChartTendencias
                :categories="chartTendenciasData.categories"
                :anulaciones="chartTendenciasData.anulaciones"
                :ventas="chartTendenciasData.ventas"
                title="Tendencias de ventas"
                subtitle="Ventas y Anulaciones"
              />
            </div>
            <div class="bg-white border-radius-lg" style="margin-top: 12px;">
              <ChartProductosColumn
                :seriesData="chartProductosDetailsData"
                title="Detalle de Ventas por Producto"
                subtitle=""
              />
            </div>
          </div>
          <div class="col-md-6 px-3 py-1">
            <div class="bg-white border-radius-lg">
              <ChartProductosPie
                :seriesData="chartProductosData"
                title="Productos"
                subtitle="Cantidad de Productos Vendidos"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from "@/examples/Cards/Card.vue";
import Datepicker from 'vuejs3-datepicker';
import * as Highcharts from "highcharts";
import "highcharts/modules/exporting";
import "highcharts/modules/offline-exporting";
import "highcharts/modules/export-data";
import "highcharts/modules/accessibility";
import "highcharts/modules/series-label";
import "highcharts/modules/drilldown";
import axios from 'axios';
import authHeader from '../services/auth-header';
import ChartTendencias from "./components/ChartTendencias.vue";
import ChartProductosPie from "./components/ChartProductosPie.vue";
import ChartProductosColumn from "./components/ChartProductosColumn.vue";

// exportingInit(Highcharts);
import US from "@/assets/img/icons/flags/US.png";
import DE from "@/assets/img/icons/flags/DE.png";
import GB from "@/assets/img/icons/flags/GB.png";
import BR from "@/assets/img/icons/flags/BR.png";
Highcharts.setOptions({
  lang: {
    decimalPoint: '.',       // Separador decimal
    thousandsSep: '',       // Separador de miles
    numericSymbols: null,    // Evita usar k, M para miles/millones si causa problemas
    exportButtonTitle: "Guardar Gráfico",
    printChart: "Imprimir",
    downloadPNG: "Descargar como PNG",
    downloadJPEG: "Descargar como JPG",
    downloadPDF: "Descargar como PDF",
    downloadSVG: "Descargar como SVG",
    downloadCSV: "Descargar como CSV",
    downloadXLS: "Descargar como XLS",
    viewData: "Ver Tabla de Datos",
    hideData: "Ocultar Tabla de Datos",
    contextButtonTitle: "Opciones de Exportación",
    viewFullscreen: "Ver en Pantalla Completa",
    exitFullscreen: "Salir de Pantalla Completa",
    loading: "Cargando..."
    // ... otras opciones de 'lang' si las necesitas
    // consulta la documentación de Highcharts API para 'lang'
  },
  credits: {
    enabled: false, // Desactiva la marca de agua de Highcharts
  },
  chart: {
    backgroundColor: '#FFF', // Cambia el color de fondo del gráfico
  },
  exporting: {
    // Deshabilitar exportación SVG (usa PNG/JPEG)
    chartOptions: {
      plotOptions: {
        series: {
          animation: false
        }
      }
    },
    // Usar exportación client-side
    libURL: 'https://code.highcharts.com/12.2.0/lib/',
    fallbackToExportServer: false,
  },
  debug: {
    enabled: true
  }
});
export default {
  name: "kardex-cliente",
  data() {
    // const vm = this;
    return {
      API_URL: process.env.VUE_APP_API_BASE_URL,
      documentoIdentidad: null,
      basicConfigDatePicker: {
        "language": "es",
        "full-month-name":true,
        "monday-first": true,
        "iconWidth": "18",
        "iconHeight": "18",
        "use-utc": true,
      },
      fechaInicio: new Date(new Date().setDate(new Date().getDate() - 7)),
      fechaFin: new Date(),
      error: null,
      stats: {
        ventas: {
          title: "Movimiento Económico",
          value: "0",
          percentage: "0",
          iconClass: "ni ni-money-coins",
          detail: "Anulaciones",
          iconBackground: "bg-gradient-primary",
        },
        cantidadProductos: {
          title: "Cantidad de Productos",
          value: "0",
          percentage: "0",
          percentageColor: "text-md",
          iconClass: "ni ni-box-2",
          iconBackground: "bg-gradient-danger",
          detail: "Unidades vendidas",
        },
        clients: {
          title: "Promedio Afiliados",
          value: "0",
          percentage: "Valor calculado según el top de Afiliados",
          iconClass: "ni ni-single-02",
          iconBackground: "bg-gradient-success",
          detail: "",
        },
        sales: {
          title: "Lider en ventas (Bs)",
          value: "...",
          valueColor: "text-xs",
          percentage: "",
          percentageColor: "text-xs",
          iconClass: "ni ni-cart",
          iconBackground: "bg-gradient-warning",
          detail: "/unidades",
        },
      },
      sales: {
        us: {
          country: "United States",
          sales: 2500,
          value: "$230,900",
          bounce: "29.9%",
          flag: US,
        },
        germany: {
          country: "Germany",
          sales: "3.900",
          value: "$440,000",
          bounce: "40.22%",
          flag: DE,
        },
        britain: {
          country: "Great Britain",
          sales: "1.400",
          value: "$190,700",
          bounce: "23.44%",
          flag: GB,
        },
        brasil: {
          country: "Brasil",
          sales: "562",
          value: "$143,960",
          bounce: "32.14%",
          flag: BR,
        },
      },
      tendencias: [],
      chartTendenciasData: {
        categories: [],
        anulaciones: [],
        ventas: []
      },
      chartProductosData: [],
      chartProductDetailsData: [],
    };
  },
  methods: {
    showMessage: function () {
      this.$toast.add({ severity: 'success', summary: 'Exito', detail: 'Su mensaje fue enviado exitosamente.', life: 3000 });
    },
    changeIsoToDate: function(isoDate) {
      let date = new Date(isoDate);
      let year = date.getFullYear();
      let month = date.getMonth()+1;
      let dt = date.getDate();
      if (dt < 10) {
        dt = '0' + dt;
      }
      if (month < 10) {
        month = '0' + month;
      }
      return year+'-' + month + '-'+dt;
    },
    getData: function () {
      if (this.documentoIdentidad) {
        this.getTendenciaVentas();
        this.getProductos();
      }
    },
    getTendenciaVentas: function () {
      this.tendencias = [];
      let payload = {
        "documento_identidad": this.documentoIdentidad,
        "fecha_inicio": this.fechaInicio ? (this.changeIsoToDate(this.fechaInicio) ?? '') : '2025-05-01',
        "fecha_fin": this.fechaFin ? (this.changeIsoToDate(this.fechaFin) ?? '') : '2025-05-08',
      }
      // Send Data by Axios
      let url = this.API_URL + "/dashboards/ventasanulaciones";
      axios({
        url: url,
        method: 'post',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
          let data = response.data.data;
          data["fechas"] = Object.keys(data.ventas);
          this.tendencias = data;
          this.chartTendenciasData.anulaciones = Object.entries(this.tendencias?.anulaciones || {});
          this.chartTendenciasData.ventas = Object.entries(this.tendencias?.ventas || {});
          this.chartTendenciasData.categories = (Array.from(this.tendencias?.fechas || []));
          // this.chartTendenciasData.plotOptions.area.pointStart = this.tendencias?.fechas[0] || 0;
          // Sum ar los valores de ventas y anulaciones
          let totalVentas = Object.values(this.tendencias?.ventas || {}).reduce((a, b) => a + b, 0);
          let totalAnulaciones = Object.values(this.tendencias?.anulaciones || {}).reduce((a, b) => a + b, 0);
          // Actualizar los valores de las estadísticas
          this.stats.ventas.value = totalVentas.toLocaleString('es-BO', { style: 'currency', currency: 'BOB' });
          this.stats.ventas.percentage = totalAnulaciones.toLocaleString('es-BO', { style: 'currency', currency: 'BOB' });
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    getProductos: function () {
      let payload = {
        "documento_identidad": this.documentoIdentidad,
        "fecha_inicio": this.fechaInicio ? (this.changeIsoToDate(this.fechaInicio) ?? '') : '2025-05-01',
        "fecha_fin": this.fechaFin ? (this.changeIsoToDate(this.fechaFin) ?? '') : '2025-05-08',
      }
      // Send Data by Axios
      let url = this.API_URL + "/dashboards/ventasproducto";
      axios({
        url: url,
        method: 'post',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
          let data = response.data.data;
          let info = [];
          let infoBs = [];
          let totalUnidadProductos = 0;
          const productos = Object.keys(data);
          productos.forEach( producto => {
            totalUnidadProductos += data[producto]?.cantidad_total ?? 0;;
            info.push({
              name: producto,
              y: data[producto]?.cantidad_total ?? 0
            })
            infoBs.push({
              name: producto,
              y: data[producto]?.precio_total ?? 0
            })
          });
          this.chartProductosData = info;
          this.chartProductosDetailsData = infoBs;
          this.stats.cantidadProductos.value = productos.length ?? 0;
          this.stats.cantidadProductos.percentage = totalUnidadProductos;
          // Usamos el método reduce para encontrar el producto con la cantidad más alta
          const productoMasCantidad = productos.reduce((a, b) => {
              return data[a].cantidad_total > data[b].cantidad_total ? a : b;
          });

          // Hacemos lo mismo para encontrar el producto con el precio más alto
          const productoMasPrecio = productos.reduce((a, b) => {
              return data[a].precio_total > data[b].precio_total ? a : b;
          });
          this.stats.sales.value = productoMasPrecio ?? "";
          this.stats.sales.percentage = productoMasCantidad ?? "";
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    validarFiltros: function () {
      this.error = '';
      if (this.fechaInicio && this.fechaFin) {
        if (this.fechaInicio > this.fechaFin) {
          this.error = 'La fecha inicial no puede ser mayor que la fecha final\n';
          // Opcional: Resetear fechas inválidas
          // fechaFin.value = null;
        }
      }
    },
    validateRoute(){
      let menus = this.getProfileMe?.data.menu.filter( menu => {
        return (menu.path.toLowerCase().indexOf(this.$route.path.substring(1)) != -1);
      });
      if ( menus.length == 0 ) {
        this.$router.push({name: 'Home'});
      }
    }
  },
  mounted() {
    this.validateRoute();
    this.getData();
  },
  watch: {
    getProfileMe(val) {
      if (val) {
        this.validateRoute();
      }
    }
  },
  computed: {
    getProfileMe() {
      return this.$store.getters["profile/me"];
    }
  },
  components: {
    Card,
    ChartTendencias,
    ChartProductosPie,
    ChartProductosColumn,
    Datepicker
  },
};
</script>
<style>
.vuejs3-datepicker__calendar {
  position: absolute !important;
}
.highcharts-drilldown-axis-label {
  fill: #000 !important;
  text-decoration: none !important;;
}
.vs__selected {
  /* color: #FFF !important; */
}

.vs__clear {
  display: none !important;
}
.error-message {
  color: red;
  font-size: 80%;
  margin-top: 10px;
  font-weight: finer;
  margin-top: 30px;
}
</style>
